<template>
    <div :class="containerClass" @click="onClick($event)">
        <div class="p-hidden-accessible">
            <input
                ref="input"
                type="checkbox"
                :checked="checked"
                :value="value"
                v-bind="$attrs"
                @focus="onFocus($event)"
                @blur="onBlur($event)"
            />
        </div>
        <div
            ref="box"
            :class="['p-checkbox-box', { 'p-highlight': checked, 'p-disabled': $attrs.disabled, 'p-focus': focused }]"
        >
            <span :class="['p-checkbox-icon', { 'pi pi-check': checked }]"></span>
        </div>
    </div>
</template>

<script>
import ObjectUtils from 'primevue/utils/ObjectUtils';

export default {
    inheritAttrs: false,
    model: {
        prop: 'modelValue',
        event: 'input',
    },
    props: {
        // eslint-disable-next-line vue/require-default-prop
        value: null,
        // eslint-disable-next-line vue/require-default-prop
        modelValue: null,
        binary: Boolean,
        trueValue: {
            type: null,
            default: true,
        },
        falseValue: {
            type: null,
            default: false,
        },
    },
    data() {
        return {
            focused: false,
        };
    },
    computed: {
        checked() {
            return this.binary ? this.modelValue === this.trueValue : ObjectUtils.contains(this.value, this.modelValue);
        },
        containerClass() {
            return [
                'p-checkbox p-component',
                {
                    'p-checkbox-checked': this.checked,
                    'p-checkbox-disabled': this.$attrs.disabled,
                    'p-checkbox-focused': this.focused,
                },
            ];
        },
    },
    methods: {
        onClick(event) {
            if (!this.$attrs.disabled) {
                let newModelValue;

                if (this.binary) {
                    newModelValue = this.checked ? this.falseValue : this.trueValue;
                } else {
                    // eslint-disable-next-line
                    if (this.checked)
                        newModelValue = this.modelValue.filter((val) => !ObjectUtils.equals(val, this.value));
                    else newModelValue = this.modelValue ? [...this.modelValue, this.value] : [this.value];
                }

                this.$emit('click', event);
                this.$emit('input', newModelValue);
                this.$emit('change', event);
                this.$refs.input.focus();
            }
        },
        onFocus(event) {
            this.focused = true;
            this.$emit('focus', event);
        },
        onBlur(event) {
            this.focused = false;
            this.$emit('blur', event);
        },
    },
};
</script>
